
import axios from "axios";
import { getCookie } from "../getcookie.js";
const apiUrl = process.env.REACT_APP_API_URL;
const gateApiUrl = process.env.REACT_APP_GATE_API_URL;

const apiAdminUrl = process.env.REACT_APP_ADMIN_API_URL;

const header = {
    "Content-Type": "application/json; charset=UTF-8",
    Accept: "application/json",
    "Access-Control-Allow-Origin": "*", // Required for CORS support to work
    Authorization: getCookie("mawalog"),
};

 export const getAssetListApi = async (params) => { 
  try {
    const response = await axios.get(
      apiUrl+`asset?`+params,
      {
        headers: header,
      }
    );
return response;
  } catch (err) {
    console.error("Error fetching category:", err);
  } finally {
  }
};

 export const getValidateScanDataApi = async (qrTag) => { 
  try {
    const response = await axios.post(
      apiUrl+`dock_scan`,{code:qrTag},
      {
        headers: header,
      }
    );
return response;
  } catch (err) {
    
    console.error("Error fetching category:", err);
    return err.response;
  } finally {
  }
};

 export const getAssetTagApi = async (type) => { 
  try {
   const response = await axios.post(
      apiUrl + `asset/tag_autogen`, {"type":type}, { headers: header }).then((response) => {
        return response;
      }).catch((error) => {
        console.log('error...', error.response)
        return error.response;
      });
    return response;
  } catch (err) {
    console.error("Error fetching category:", err);
  } finally {
  }
};

export const createAssetApi = async (data) => {
  try {
    const response = await axios.post(
      apiUrl + `asset`, data, { headers: header }).then((response) => {
        return response;
      }).catch((error) => {
        console.log('error...', error.response)
        return error.response;
      });
    return response;
  } catch (err) {
    console.error("Error fetching category:", err);
  } finally {
  }
};
export const updateAssetApi = async (id, data) => {
  try {
    const response = await axios.put(
      apiUrl + `asset/` + id, data, { headers: header }).then((response) => {
        return response;
      }).catch((error) => {
        console.log('error...', error.response)
        return error.response;
      });
    return response;
  } catch (err) {
    console.error("Error fetching category:", err);
  } finally {
  }
};

 export const getAssetApi = async (id) => { 
  try {
    const response = await axios.get(
      apiUrl+`asset/edit/`+id,
      {
        headers: header,
      }
    );
return response;
  } catch (err) {
    console.error("Error fetching category:", err);
  } finally {
  }
};

export const validateRemainderApi = async (data) => {
  try {
    const response = await axios.post(
      apiUrl + `reminder_validation`, data, { headers: header }).then((response) => {
        return response;
      }).catch((error) => {
        console.log('error...', error.response)
        return error.response;
      });
    return response;
  } catch (err) {
    console.error("Error fetching category:", err);
  } finally {
  }
};

export const uploadProfileAttachmentApi = async (id,data) => {
  try {
    const response = await axios.post(
      apiUrl + `asset/profile/`+id, data, { headers: header }).then((response) => {
        return response;
      }).catch((error) => {
        console.log('error...', error.response)
        return error.response;
      });
    return response;
  } catch (err) {
    console.error("Error fetching category:", err);
  } finally {
  }
};

export const uploadAttachmentApi = async (id,data) => {
  try {
    const response = await axios.post(
      apiUrl + `asset/attachment/`+id, data, { headers: header }).then((response) => {
        return response;
      }).catch((error) => {
        console.log('error...', error.response)
        return error.response;
      });
    return response;
  } catch (err) {
    console.error("Error fetching category:", err);
  } finally {
  }
};
 export const getAssetProfileApi = async (id) => { 
  try {
    const response = await axios.get(
      apiUrl+`asset/profile/`+id,
      {
        headers: header,
      }
    );
return response;
  } catch (err) {
    console.error("Error fetching category:", err);
  } finally {
  }
};
 export const getAssetAttachmentApi = async (id) => { 
  try {
    const response = await axios.get(
      apiUrl+`asset/attachment/`+id,
      {
        headers: header,
      }
    );
return response;
  } catch (err) {
    console.error("Error fetching category:", err);
  } finally {
  }
};
export const getAssetReminderApi = async (id) => { 
  try {
    const response = await axios.get(
      apiUrl+`reminder/`+id,
      {
        headers: header,
      }
    );
return response;
  } catch (err) {
    console.error("Error fetching category:", err);
  } finally {
  }
};


export const getAssetInfoApi = async (tag) => { 
  try {
    const response = await axios.get(
      apiUrl+`get_asset?asset_tag=`+tag,
      {
        headers: header,
      }
    );
return response;
  } catch (err) {
    console.error("Error fetching category:", err);
  } finally {
  }
};

export const submitAssetCheckingApi = async (data) => {
  try {
    const response = await axios.post(
      apiUrl + `checking`, data, { headers: header }).then((response) => {
        return response;
      }).catch((error) => {
        console.log('error...', error.response)
        return error.response;
      });
    return response;
  } catch (err) {
    console.error("Error fetching category:", err);
  } finally {
  }
};


export const getDeleteApi = async (deleteUrl) => {

  try {
    const response = await axios.delete(
      apiUrl + deleteUrl,
      {
        headers: header,
      }
    );
    return response;
  } catch (err) {

    console.error("Error fetching category:", err);
    return err.response;
  } finally {
  }
};
// export const getDeleteAdminApi = async (deleteUrl) => {

//   try {
//     const response = await axios.delete(
//       adminApiUrl + deleteUrl,
//       {
//         headers: header,
//       }
//     );
//     return response;
//   } catch (err) {

//     console.error("Error fetching category:", err);
//     return err.response;
//   } finally {
//   }
// };

export const bulkDeleteApi = async (deleteUrl, ids) => {

  try {
    const response = await axios.delete(
      apiUrl + deleteUrl,
      {
        headers: header,
        data: { "id": ids }
      },
    );
    return response;
  } catch (err) {

    console.error("Error fetching category:", err);
    return err.response;
  } finally {
  }
};

export const createReminderApi = async (data) => {
  try {
    const response = await axios.post(
      apiUrl + `reminder`, data, { headers: header }).then((response) => {
        return response;
      }).catch((error) => {
        console.log('error...', error.response)
        return error.response;
      });
    return response;
  } catch (err) {
    console.error("Error fetching category:", err);
  } finally {
  }
};
export const updateReminderApi = async (id, data) => {
  try {
    const response = await axios.put(
      apiUrl + `reminder/` + id, data, { headers: header }).then((response) => {
        return response;
      }).catch((error) => {
        console.log('error...', error.response)
        return error.response;
      });
    return response;
  } catch (err) {
    console.error("Error fetching category:", err);
  } finally {
  }
};

export const uploadAssetApi = async (data) => {
  try {
    const response = await axios.post(
      apiUrl + `asset_upload`, data, { headers: header }).then((response) => {
        return response;
      }).catch((error) => {
          if (error.response) {
            console.error("Error Status:", error.response.status);
            console.error("Error Data:", error.response.data);
            if (error.response.status === 400) {
            }
          /*   setSnackbarMessage(error.response.data.message);
            setSnackbarStatus(error.response.data.success);
            handleSnackbarShow(); */
            if (error.response.data.base64 != null && error.response.data.base64 !== "") {
              const base64String = error.response.data.base64; // Truncated for brevity
              const fileName = "Asset_Upload_Error" + new Date().getTime() + ".xlsx";

              // Convert Base64 to Blob
              const binary = atob(base64String);
              const array = [];
              for (let i = 0; i < binary.length; i++) {
                array.push(binary.charCodeAt(i));
              }
              const blob = new Blob([new Uint8Array(array)], {
                type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
              });

              // Create a link and trigger download
              const link = document.createElement("a");
              link.href = URL.createObjectURL(blob);
              link.download = fileName;
              document.body.appendChild(link);
              link.click();
              document.body.removeChild(link);
            }
             return error.response;
          } else {
            console.error("Request failed:", error.message);
          }
        });;
    return response;
  } catch (err) {
    console.error("Error fetching category:", err);
  } finally {
  }
};

export const templateDownloadApi = async () => {
   try {
    const response = await axios.get(
      apiUrl+`template_download`,
      {
        headers: header,
      }
    );
return response;
  } catch (err) {
    console.error("Error fetching category:", err);
  } finally {
  }  
};

export const saveDataEntryApi = async (id,data) => {
  try {
    const response = await axios.post(
      apiUrl + `asset/date_entry/${id}`, data, { headers: header }).then((response) => {
        return response;
      }).catch((error) => {
        console.log('error...', error.response)
        return error.response;
      });
    return response;
  } catch (err) {
    console.error("Error fetching category:", err);
  } finally {
  }
};

export const getReferenceApi = async (id) => { 
  try {
    const response = await axios.get(
      apiUrl+`asset/reference/`+id,
      {
        headers: header,
      }
    );
return response;
  } catch (err) {
    console.error("Error fetching category:", err);
  } finally {
  }
};
